<!-- Client Details Popup -->
<div class="popup-overlay" [class.show]="visible" (click)="close()">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h4 class="popup-title">
        <i class="fas fa-building me-2"></i>
        Dettagli Cliente<ng-container *ngIf="client">: {{ client.clientName || client.clientCode }}</ng-container>
      </h4>
      <button type="button" class="btn-close" (click)="close()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">

      <!-- Caricamento -->
      <div class="state-box" *ngIf="isLoading">
        <i class="fas fa-spinner fa-spin fa-2x text-muted mb-3"></i>
        <p class="mb-0 text-muted">Caricamento dati cliente...</p>
      </div>

      <!-- Errore -->
      <div class="state-box" *ngIf="!isLoading && hasError">
        <i class="fas fa-exclamation-triangle fa-2x text-danger mb-3"></i>
        <p class="mb-1 fw-semibold">Impossibile recuperare i dati del cliente</p>
        <p class="text-muted mb-0 small">Codice cliente: {{ clientCode }}</p>
      </div>

      <div class="client-details" *ngIf="!isLoading && !hasError && client">

        <!-- Header riepilogo -->
        <div class="details-summary">
          <div class="details-summary-item">
            <i class="fas fa-building"></i>
            <span>Cliente: <strong>{{ client.clientName || client.clientCode }}</strong></span>
          </div>
          <div class="details-summary-item" *ngIf="client.clientOperatingAddressCity">
            <i class="fas fa-city"></i>
            <span>{{ client.clientOperatingAddressCity }}<ng-container *ngIf="client.clientOperatingAddressProvince"> ({{ client.clientOperatingAddressProvince }})</ng-container></span>
          </div>
          <div class="details-summary-item" *ngIf="client.clientStatus">
            <span class="details-status-badge" [ngClass]="getStatusBadgeClass()">
              <i class="fas fa-circle status-dot"></i>
              {{ client.clientStatus }}
            </span>
          </div>
        </div>

        <!-- Identificazione -->
        <div class="details-card">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-id-card"></i></div>
            <h5 class="details-card-title">Identificazione</h5>
          </div>
          <div class="details-card-body">
            <div class="details-grid">
              <div class="details-item">
                <span class="details-label">Codice Cliente</span>
                <div class="details-value details-value--code">
                  <span>{{ client.clientCode || '-' }}</span>
                  <i *ngIf="client.clientCode" class="fas fa-copy copy-icon"
                     (click)="copyToClipboard(client.clientCode)" title="Copia codice cliente"></i>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Ragione Sociale</span>
                <div class="details-value">
                  <span>{{ client.clientName || '-' }}</span>
                  <i *ngIf="client.clientName" class="fas fa-copy copy-icon"
                     (click)="copyToClipboard(client.clientName)" title="Copia ragione sociale"></i>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Acronimo</span>
                <div class="details-value details-value--code">
                  <span>{{ client.clientAcronym || '-' }}</span>
                  <i *ngIf="client.clientAcronym" class="fas fa-copy copy-icon"
                     (click)="copyToClipboard(client.clientAcronym)" title="Copia acronimo"></i>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Codice Azienda</span>
                <div class="details-value details-value--code">
                  <span>{{ client.clientCompanyCode || '-' }}</span>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">ID Interno</span>
                <div class="details-value details-value--code">
                  <span>{{ client.clientInternalId || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Dati Fiscali -->
        <div class="details-card" *ngIf="client.clientVatNumber || client.clientSdiCode || client.clientInternalBillingId">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-file-invoice-dollar"></i></div>
            <h5 class="details-card-title">Dati Fiscali</h5>
          </div>
          <div class="details-card-body">
            <div class="details-grid">
              <div class="details-item" *ngIf="client.clientVatNumber">
                <span class="details-label">Partita IVA</span>
                <div class="details-value details-value--code">
                  <span>{{ client.clientVatNumber }}</span>
                  <i class="fas fa-copy copy-icon" (click)="copyToClipboard(client.clientVatNumber)" title="Copia partita IVA"></i>
                </div>
              </div>
              <div class="details-item" *ngIf="client.clientSdiCode">
                <span class="details-label">Codice SDI</span>
                <div class="details-value details-value--code">
                  <span>{{ client.clientSdiCode }}</span>
                  <i class="fas fa-copy copy-icon" (click)="copyToClipboard(client.clientSdiCode)" title="Copia codice SDI"></i>
                </div>
              </div>
              <div class="details-item" *ngIf="client.clientInternalBillingId">
                <span class="details-label">ID Fatturazione</span>
                <div class="details-value details-value--code">
                  <span>{{ client.clientInternalBillingId }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Indirizzo Legale -->
        <div class="details-card" *ngIf="hasLegalAddress()">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-building"></i></div>
            <h5 class="details-card-title">Indirizzo Legale</h5>
          </div>
          <div class="details-card-body">
            <div class="details-value details-value--stacked">
              <div *ngIf="client.clientLegalAddressStreet">
                <i class="fas fa-road me-1 text-muted"></i>
                {{ client.clientLegalAddressStreet }} {{ client.clientLegalAddressNumber }}
              </div>
              <div *ngIf="client.clientLegalAddressZip || client.clientLegalAddressCity">
                <i class="fas fa-city me-1 text-muted"></i>
                {{ client.clientLegalAddressZip }} {{ client.clientLegalAddressCity }}
                <ng-container *ngIf="client.clientLegalAddressProvince">({{ client.clientLegalAddressProvince }})</ng-container>
              </div>
              <div *ngIf="client.clientLegalAddressCountry">
                <i class="fas fa-globe-europe me-1 text-muted"></i>
                {{ client.clientLegalAddressCountry }}
              </div>
            </div>
          </div>
        </div>

        <!-- Indirizzo Operativo -->
        <div class="details-card" *ngIf="hasOperatingAddress()">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-warehouse"></i></div>
            <h5 class="details-card-title">Indirizzo Operativo</h5>
          </div>
          <div class="details-card-body">
            <div class="details-value details-value--stacked">
              <div *ngIf="client.clientOperatingAddressStreet">
                <i class="fas fa-road me-1 text-muted"></i>
                {{ client.clientOperatingAddressStreet }} {{ client.clientOperatingAddressNumber }}
              </div>
              <div *ngIf="client.clientOperatingAddressZip || client.clientOperatingAddressCity">
                <i class="fas fa-city me-1 text-muted"></i>
                {{ client.clientOperatingAddressZip }} {{ client.clientOperatingAddressCity }}
                <ng-container *ngIf="client.clientOperatingAddressProvince">({{ client.clientOperatingAddressProvince }})</ng-container>
              </div>
              <div *ngIf="client.clientOperatingAddressCountry">
                <i class="fas fa-globe-europe me-1 text-muted"></i>
                {{ client.clientOperatingAddressCountry }}
              </div>
              <a *ngIf="hasCoordinates()" [href]="getCoordinatesMapUrl()" target="_blank" class="btn btn-sm btn-outline-primary mt-2">
                <i class="fas fa-external-link-alt me-1"></i>Apri in Google Maps
              </a>
            </div>
          </div>
        </div>

        <!-- Informazioni Aggiuntive -->
        <div class="details-card">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-info-circle"></i></div>
            <h5 class="details-card-title">Informazioni Aggiuntive</h5>
          </div>
          <div class="details-card-body">
            <div class="details-grid">
              <div class="details-item">
                <span class="details-label">Stato</span>
                <div class="details-value">
                  <span class="details-status-badge" *ngIf="client.clientStatus; else noStatus" [ngClass]="getStatusBadgeClass()">
                    <i class="fas fa-circle status-dot"></i>
                    {{ client.clientStatus }}
                  </span>
                  <ng-template #noStatus><span class="text-muted">-</span></ng-template>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Settore</span>
                <div class="details-value">{{ client.clientIndustry || '-' }}</div>
              </div>
              <div class="details-item">
                <span class="details-label">Data Costituzione</span>
                <div class="details-value">{{ client.clientIncorporationDate ? (client.clientIncorporationDate | date:'dd/MM/yyyy') : '-' }}</div>
              </div>
              <div class="details-item">
                <span class="details-label">Raggio Massimo</span>
                <div class="details-value">{{ client.clientMaximumRange != null ? client.clientMaximumRange : '-' }}</div>
              </div>
              <div class="details-item">
                <span class="details-label">Tipo Indirizzo Bolla</span>
                <div class="details-value">{{ client.clientWaybillAddressType || '-' }}</div>
              </div>
              <div class="details-item">
                <span class="details-label">Firma Richiesta</span>
                <div class="details-value">
                  <span class="details-status-badge" [ngClass]="isSignatureRequired() ? 'status-executed' : 'status-unknown'">
                    {{ isSignatureRequired() ? 'Sì' : 'No' }}
                  </span>
                  <span *ngIf="isSignatureRequired() && client.clientSignatureType" class="text-muted small">{{ client.clientSignatureType }}</span>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Dealer Autogenerato</span>
                <div class="details-value">
                  <span class="details-status-badge" [ngClass]="client.clientIsAutoGeneratedDealer ? 'status-executed' : 'status-unknown'">
                    {{ client.clientIsAutoGeneratedDealer ? 'Sì' : 'No' }}
                  </span>
                </div>
              </div>
              <div class="details-item">
                <span class="details-label">Giustificazioni Personalizzate</span>
                <div class="details-value">
                  <span class="details-status-badge" [ngClass]="client.clientIsPersonalJustifications ? 'status-executed' : 'status-unknown'">
                    {{ client.clientIsPersonalJustifications ? 'Sì' : 'No' }}
                  </span>
                </div>
              </div>
              <div class="details-item" *ngIf="client.clientCreatedAt">
                <span class="details-label">Data Creazione</span>
                <div class="details-value">{{ client.clientCreatedAt | date:'dd/MM/yyyy HH:mm' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Note -->
        <div class="details-card" *ngIf="client.clientNote">
          <div class="details-card-header">
            <div class="details-card-icon"><i class="fas fa-sticky-note"></i></div>
            <h5 class="details-card-title">Note</h5>
          </div>
          <div class="details-card-body">
            <div class="details-notes">{{ client.clientNote }}</div>
          </div>
        </div>

      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="fas fa-times me-2"></i>
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
